function importAll(r) {
    return r.keys().map(r);
}

const equipmentImages = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentText = [
    { name: `Dutch oven`, note: `if making sauce` },
    { name: `Baking sheets (2)`},
    { name: `Food processor or blender`, note: `optional`},
    { name: `Large skillet/pan`, note: `preferably cast iron` },
    { name: `Glass baking dish`, note: `9x13"` }, 
    { name: `Tinfoil` }, 
]

export const equipment = equipmentText.map((item, index) => {
    return {
        name: item.name,
        note: item.note, 
        img: equipmentImages[index]
    }
})